import { http } from './base/http';

export const SVGFileAPIs = {
    async uploadSVGFile(
        file: File,
        onProgress: (ev: ProgressEvent) => void,
        onDone: (ev: ProgressEvent) => void,
    ): Promise<XMLHttpRequest> {
        const formData = new FormData();
        formData.append('file', file);
        return http.upload('/svg_files', 'POST', formData, onProgress, onDone);
    },
};
